import React, { useCallback, useEffect, useState } from 'react';

import { ActionInviteFriends } from './ActionInviteFriends';
import { CardChangeTdaVip } from './CardChangeTdaVip';
import { CardPosition } from './CardPosition';
import { RankingTable } from './RankingTable';

import { ArrowDateSelector } from '@/components/GenericsTournaments/ArrowDateSelector';
import { Tabs, DefaultTabsProps } from '@/components/Tabs';
import { TabType } from '@/components/Types';
import { useHandleChangesTabs } from '@/hooks/useHandleChangesTabs';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import useTourney from '@/hooks/useTourney';
import { TopRankingTDA } from '@/types/tda';
import { GENERICS_WORDS } from '@/utils';

type Props = {
  onClickChangeToVip: () => void;
};

export const RankingSelector = React.memo(({ onClickChangeToVip }: Props) => {
  const { tab, handleTabChanges } = useHandleChangesTabs();
  const { isMobile } = useIsDesktop();
  const [dataTable, setDataTable] = useState<TopRankingTDA[]>([]);
  const { tourneyData, handleSetTourney } = useTourney();

  const onHandleInit = useCallback(() => {
    if (tab === TabType.FirstTab) {
      setDataTable(() => {
        return (
          tourneyData?.tourney?.top_fecha?.map((item: TopRankingTDA) => ({
            ...item,
            isGeneral: false,
          })) || []
        );
      });
    } else {
      setDataTable(() => {
        return (
          tourneyData?.tourney?.top_general?.map((item: TopRankingTDA) => ({
            ...item,
            isGeneral: true,
          })) || []
        );
      });
    }
    handleSetTourney({ ...tourneyData, subMainTab: tab });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, tourneyData?.tourney]);

  // init
  useEffect(() => {
    onHandleInit();
  }, [onHandleInit]);

  // reseteo tab secundario si cambia tab principal
  useEffect(() => {
    handleTabChanges(TabType.FirstTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tourneyData.mainTab]);

  const tabs: DefaultTabsProps['tabs'] = [
    { name: GENERICS_WORDS.date },
    { name: GENERICS_WORDS.gral },
  ];

  return (
    <>
      {/* tabs de fecha o torneo */}
      <div className="text-center lg:pt-6">
        <Tabs
          activeTab={tab}
          className="mt-2 lg:max-w-none lg:h-[38px] lg:mt-0 lg:justify-center lg:w-full"
          classNameTabs="lg:max-w-[200px]"
          tabs={tabs}
          variant="underline"
          onClick={handleTabChanges}
        />
      </div>

      {/* selector de fechas */}
      <ArrowDateSelector
        key={
          tourneyData.mainTab ||
          tourneyData.rankingAvailable.filter((item) => item.id).join() ||
          tourneyData.matchDay?.nombre
        } // reseteo selector de fechas si cambia tab primario o nuevo torneo
        matchsDaysAvailables={tourneyData.rankingAvailable}
      />
      {/* card posicion en ... */}
      {isMobile && <CardPosition tab={tab} tourney={tourneyData.tourney} />}

      {/* // cambiar torneo comun a vip */}
      {isMobile && !tourneyData.isVip && tourneyData.isOwner ? (
        <CardChangeTdaVip onClickChangeToVip={onClickChangeToVip} />
      ) : (
        <div className="mt-7" />
      )}

      {/* tabla de ranking */}
      <RankingTable
        dataTable={dataTable}
        isFirstMathDayRanking={Boolean(
          tourneyData.initDay &&
            tourneyData.matchDay &&
            tourneyData.initDay >= tourneyData.matchDay?.orden
        )}
        isGeneral={tab === TabType.SecondTab}
        rankingAvailable={tourneyData.rankingAvailable.length > 0}
      />

      {isMobile && tourneyData.isOwner && (
        <div className="text-center">
          <ActionInviteFriends className="my-6" />
        </div>
      )}
    </>
  );
});

RankingSelector.displayName = 'RankingSelector';
